import styled, { keyframes, css } from "styled-components";

export const borderWidth = 3;

export const Screens = styled.div`
    position: relative;
    margin: auto;
    margin-bottom: 20px;
`;

export const Screen = styled.div`
    box-shadow: 0 0 0 ${borderWidth}px ${p => p.theme.c.boost} inset;
    position: absolute;
    transition: background-color 300ms;
    background-color: ${p => p.theme.c.snowOnActive};
    &.StartScreen {
        background-color: ${p => p.theme.c.disabled};
    }
    &.Active {
        background-color: ${p => p.theme.c.pale};
    }
`;

export const TaskIcons = styled.div`
    margin: auto;
    z-index: 1;
    position: relative;
`;

export const Positioner = styled.div`
    position: absolute;
    top: 0;
    left: 0;
`;

const pulsate = keyframes`
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.7;
        transform: scale(1.1);
    }
    100% {
        opacity: 1;
    }
`;

export const IconScaler = styled.div`
    transform-origin: top left;
    user-select: none;
    cursor: pointer;
    position: relative;
`;

export const IconScalerDrag = styled(IconScaler)`
`;

export const IconPulsator = styled.div`
    transform-origin: center;
    &.Pulsating {
        animation: ${pulsate} infinite 1s;
    }
`;

export const NotSet = styled.div`
    text-align: center;
    h3 {
        height: 100px;
        margin: 32px 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    button {
        margin-bottom: 48px;
    }
`;

export const Form = styled.div`
    ${p => p.theme.sm.max(css`
        margin: auto;
    `)}
    ${p => p.theme.md.min(css`
        padding-right: 20px;
    `)}
    margin-bottom: 8px;
`;


export const Wrapper = styled.div`
    display: flex;
    ${p => p.theme.sm.max(css`
        flex-direction: column;
    `)}
`;


export const Difficulty = styled.div`
    position: absolute;
    top: -2px;
    left: 55px;
    width: 24px;
    height: 24px;
    border-radius: 15px;
    box-shadow: 0 0 3px 0 ${p => p.theme.c.blackShadow3};
    color: ${p => p.theme.c.white};
    display: flex;
    align-items: center;
    justify-content: center;

    .i-chevron-right {
        font-size: 17px;
        font-weight: 800;
    }

    &.Hard {
        background-color: ${p => p.theme.c.incorrect};
        .i-chevron-right {
            transform: rotate(-90deg) translateX(1px);
        }
    }
    &.Easy {
        background-color: ${p => p.theme.c.correct};
        .i-chevron-right {
            transform: rotate(90deg) translateX(1px);
        }
    }
`;

export const ChristmasIcon = styled.img`
    width: 42px;
    height: 42px;
`;